import { createSelector } from 'reselect';


const _selectLeadStates = (state: DefaultRootState) => state?.leadStates;

export const selectStates = createSelector(
  [_selectLeadStates],
  (leadStates) => leadStates?.list || []
)

export const selectAppointmentEventsMap = createSelector(
  [_selectLeadStates],
  (leadStates) => leadStates?.appointmentEventsMap || {}
)

export const selectLeadStateById = createSelector(
  [selectStates, (_, leadStateId) => leadStateId],
  (states, leadStateId) => states.find(state => state.id === leadStateId)
);
